import React from 'react';

const FullPageLoader = ({ message = 'Loading...' }) => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
      <div className="flex flex-col items-center space-y-6">
        {/* Logo with spinning animation */}
        <div className="relative">
          <img 
            src="/logo-new.jpg" 
            alt="DK Farms Logo" 
            className="w-32 h-32 object-contain animate-spin-slow"
            style={{
              animation: 'spin 3s linear infinite'
            }}
          />
        </div>
        
        {/* Loading message */}
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-700">{message}</p>
          <div className="mt-4 flex justify-center space-x-2">
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0s', animationDuration: '1.4s' }}></div>
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s', animationDuration: '1.4s' }}></div>
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.4s', animationDuration: '1.4s' }}></div>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default FullPageLoader;

